{
  "ChangeUserAgent_Title": "Imposta il profilo di visualizzazione del browser",
  "ChangeUserAgent_SubTitle": "Seleziona il profilo di visualizzazione del browser con cui desideri visualizzare il contenuto della pagina web durante la sessione web corrente su questo computer.",
  "ChangeUserAgent_FieldName_BrowserProfile": "Profilo del browser",
  "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Forza rilevamento automatico del browser]",
  "ChangeUserAgent_FooterActions_Apply": "Fare domanda a",
  "ChangeUserAgent_FooterActions_Cancel": "Cancellare",
  "NAME": "ChangeUserAgentLanguage"
}